import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
import List from './List.vue';
import Edit from './Edit.vue';
import { mapGetters } from 'vuex';
export default {
  components: {
    List: List,
    Edit: Edit
  },
  data: function data() {
    return {
      isShowList: true,
      isShowEdit: false
    };
  },
  methods: {
    // 返回
    cbOnHandleBlackBtn: function cbOnHandleBlackBtn() {
      this.$refs.List.getLoadData();
    },
    onHandleOrderNum: function onHandleOrderNum(data) {
      this.$refs.Edit.setTabelHeaderData(data);
    }
  },
  watch: {
    $DeliveryCodeOrderState: {
      handler: function handler(nawValue) {
        // console.log('单据操作状态==>',nawValue);
        if (nawValue === 'listShow') {
          // 订单列表
          this.isShowList = true;
          this.isShowEdit = false;
        } else if (nawValue === 'addOrder') {
          // 新增订单
          this.isShowList = false;
          this.isShowEdit = true;
        } else if (nawValue === 'orderShow') {
          // 订单明细
          this.isShowList = false;
          this.isShowEdit = true;
        } else if (nawValue === 'editOrder') {}
      },
      immediate: true
    }
  },
  computed: _objectSpread({}, mapGetters(['$DeliveryCodeOrderState']))
};